import { BASE_URL } from '../../constants/api';
import api from '../../services/api';

export const fetchShowrooms = async () => {
  try {
    const result = await api.get(`${BASE_URL}maps/showrooms`);
    return result.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchZipcodeLevel = async (year) => {
  try {
    const result = await api.get(`${BASE_URL}maps/data?fiscal_year=${year}&level=zip`);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchCountyLevel = async (year) => {
  try {
    const result = await api.get(`${BASE_URL}maps/data?fiscal_year=${year}&level=county`);
    return result.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchWonOpps = async (year) => {
  try {
    const result = await api.get(`${BASE_URL}maps/data?fiscal_year=${year}&level=won_opps`);
    return result.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPivotRange = async ({ pivotValue, year, level }) => {
  try {
    let result;
    let range = 10;
    if (pivotValue === 'penetration_rate') {
      result = await api.get(
        `${BASE_URL}maps/range?fiscal_year=${year}&level=${level}&pivot=${pivotValue}&num_ranges=${range}`
      );
    } else {
      result = await api.get(
        `${BASE_URL}maps/range?fiscal_year=${year}&level=${level}&pivot=${pivotValue}`
      );
    }
    return result.data;
  } catch (error) {
    console.error(error);
  }
};
